import hyperdom from 'hyperdom'
import ReturnCriteria from './returnCriteria.jsx'
import MultiCityCriteria from './multiCityCriteria.jsx'
import * as gtmDataLayer from '../analytics/gtm/dataLayer.js'
import {Message, MessageTypes} from '../message.jsx'

function doIf (expression, render) {
  if (expression) return render()
}

export default class Criteria {
  constructor (model) {
    this.model = model
    this.returnCriteria = new ReturnCriteria(model)
    this.multiCityCriteria = new MultiCityCriteria(model)
    this.showTabs = model.flights.allowedActions.IsMultiStopAllowed && model.config.flights.isMultiCityEnabled
  }

  onupdate () {
    gtmDataLayer.activateOptimize()
  }

  render () {
    var model = this.model
    var flights = model.flights
    flights.criteria = !flights.criteria ?  this.returnCriteria : flights.criteria

    return <div class="flights-criteria__container">
      {
        model.showFlightsRemovedForPartyWarning ?
          new Message({
            className: 'flights-removed-warning',
            header: 'Flights removed',
            message: 'As you have added or removed people from your party you will need to search for flights again.',
            type: MessageTypes.WARNING,
          })
          : undefined
      }
      {doIf(this.showTabs, () => {
        return <div class="flights__criteria-tabs">
          <button
            class={["return", "btn-mini", {"-selected": flights.criteria instanceof ReturnCriteria}]}
            onclick={() => {flights.criteria = this.returnCriteria; return false}}>Round trip</button>
          <button
            class={["multi-city", "btn-mini", {"-selected": flights.criteria instanceof MultiCityCriteria}]}
            onclick={() => {flights.criteria = this.multiCityCriteria; return false}}>Multi-City</button>
        </div>
      })}
      <div className='flights__search-inner'>
        {flights.criteria}
      </div>
    </div>
  }
}
